export default __webpack_public_path__ + "static/media/4.897b20c3.jpg";